import { render, staticRenderFns } from "./ProductSchedule.vue?vue&type=template&id=f477c0fe&scoped=true"
import script from "./ProductSchedule.vue?vue&type=script&lang=js"
export * from "./ProductSchedule.vue?vue&type=script&lang=js"
import style0 from "./ProductSchedule.vue?vue&type=style&index=0&id=f477c0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f477c0fe",
  null
  
)

export default component.exports